/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EcommerceProductImportPageVo } from './EcommerceProductImportPageVo';
import {
    EcommerceProductImportPageVoFromJSON,
    EcommerceProductImportPageVoFromJSONTyped,
    EcommerceProductImportPageVoToJSON,
    EcommerceProductImportPageVoToJSONTyped,
} from './EcommerceProductImportPageVo';

/**
 * 
 * @export
 * @interface ResponseEcommerceProductImportPageVo
 */
export interface ResponseEcommerceProductImportPageVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseEcommerceProductImportPageVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseEcommerceProductImportPageVo
     */
    message?: string;
    /**
     * 
     * @type {EcommerceProductImportPageVo}
     * @memberof ResponseEcommerceProductImportPageVo
     */
    data?: EcommerceProductImportPageVo;
}

/**
 * Check if a given object implements the ResponseEcommerceProductImportPageVo interface.
 */
export function instanceOfResponseEcommerceProductImportPageVo(value: object): value is ResponseEcommerceProductImportPageVo {
    return true;
}

export function ResponseEcommerceProductImportPageVoFromJSON(json: any): ResponseEcommerceProductImportPageVo {
    return ResponseEcommerceProductImportPageVoFromJSONTyped(json, false);
}

export function ResponseEcommerceProductImportPageVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseEcommerceProductImportPageVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : EcommerceProductImportPageVoFromJSON(json['data']),
    };
}

export function ResponseEcommerceProductImportPageVoToJSON(json: any): ResponseEcommerceProductImportPageVo {
    return ResponseEcommerceProductImportPageVoToJSONTyped(json, false);
}

export function ResponseEcommerceProductImportPageVoToJSONTyped(value?: ResponseEcommerceProductImportPageVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': EcommerceProductImportPageVoToJSON(value['data']),
    };
}

